
<template>
<div>
  {{data.data}}
</div>
</template>
<script>

export default {
  props: ['data'],
  data() {
    return {}
  },
  methods: {
  }
}
</script>